<script>
export default {
    name: "PendingInvestigation",

    props: {

        showModal: Boolean,
        pendingInvestigations: Array,
        filterPending: Object,
        floors: Array,
    },

    methods: {

        printPendingInvestigations() {

            window.open(
                `/lab/pending-investigations-print`, 
                '_blank', `LabPendingInvestigationsPrint`, 
                "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },
        
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-10/12 w-11/12">
      <template v-slot:title>
        <h5 class="font-medium text-sm">Pending Investigations</h5>
      </template>
      <template v-slot:modal-body>
        <div class="w-full flex flex-wrap -m-3">
            <div class="md:w-1/4 w-full p-1">
                <label for="grid-search-pending" class="label-control">Search:</label> 
                <input type="text" 
                    v-model.trim="filterPending.search"
                    id="grid-search-pending" class="input-control input-sm text-xs">
            </div>
            <div class="md:w-1/6 sm:w-1/2 p-tiny">
                <label for="grid-floor" class="label-control">Floor</label>
                <tail-select>
                  <template v-slot:field>
                    <select
                      v-model="filterPending.floorId"
                      id="grid-floor"
                      class="input-control input-sm text-xs"
                    >
                      <option :value="0">select floor</option>
                      <option
                        v-for="floor in floors"
                        :key="`__${floor.floorID}`"
                        :value="floor.floorID"
                        >{{ floor.floor }}</option
                      >
                    </select>
                  </template>
                </tail-select>
              </div>
            <div class="md:w-1/12 w-full p-1 mt-3">
                <button 
                    @click.prevent="$emit(`filterBySearch`, filterPending.search,filterPending.floorId)"
                    class="btn-sm btn-primary text-xs rounded">
                        <i class="fa fa-search"></i> Search</button>
            </div>
            <div class="w-full overflow-auto">
                <table class="table">
                    <thead class="bg-blue-500 text-white text-xs">
                        <tr class="w-full flex">
                            <th class="w-1/12 p-tiny">Date</th>
                            <th class="w-1/6 p-tiny">Patient</th>
                            <th class="flex-1 p-tiny">MRN</th>
                            <th class="flex-1 p-tiny">IP File No</th>
                            <th class="flex-1 p-tiny">OP File No</th>
                            <th class="w-1/12 p-tiny">DOB</th>
                            <th class="flex-1 p-tiny">Ward</th>
                            <th class="flex-1 p-tiny">Bed</th>
                            <th class="w-1/5 p-tiny">Payment Mode</th>
                            <th class="w-1/5 p-tiny">Investigation</th>
                        </tr>
                    </thead>
                    <tbody class="flex flex-col items-center text-xs overflow-auto bg-gray-100"
                        style="max-height:65vh">
                        <tr class="w-full flex" 
                            v-for="(investigation,idx) in pendingInvestigations" :key="idx">
                            <td class="p-tiny w-1/12">{{ investigation.date | dateFormat }}</td>
                            <td class="p-tiny w-1/6">{{ investigation.names }}</td>
                            <td class="p-tiny flex-1">{{ investigation.patienT_ID }}</td>
                            <td class="p-tiny flex-1">{{ investigation.ipfileno || `-` }}</td>
                            <td class="p-tiny flex-1">{{ investigation.opfileno || `-` }}</td>
                            <td class="p-tiny w-1/12">{{ investigation.dob |dateFormat }}</td>
                            <td class="p-tiny flex-1">{{ investigation.ward || `-` }}</td>
                            <td class="p-tiny flex-1">{{ investigation.bed || `-` }}</td>
                            <td class="p-tiny w-1/5">{{ investigation.pMode }}</td>
                            <td class="p-tiny w-1/5">{{ investigation.itemName }}</td>
                        </tr>
                    </tbody>
                    <tfoot class="bg-gray-300">
                        <tr class="w-full flex">
                            <td colspan="9" class="flex-1 p-tiny"></td>
                            <td class="w-1/5 p-tiny">
                                Total: {{pendingInvestigations.length}}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button 
            class="btn-danger btn-sm text-sm rounded mr-6" 
            @click="$emit(`closeModal`)">
                <i class="fa fa-times"></i> Close</button>
        <button
            @click.prevent="printPendingInvestigations" 
            class="btn-primary btn-sm text-sm rounded">
                <i class="fa fa-print"></i> Print</button>
      </template>
    </tail-modal>
</template>